import CopyLink from "./components/copy-link";
import Menu from "./components/menu";
import Modal from "./components/modal";
import NextSlider from "./components/next-slider";
import Select from "./components/select";
import ServicesSlider from "./components/services-slider";
import Slider from "./components/slider";
import Tabs from "./components/tabs";
import Toggle from "./components/toggle";

document.addEventListener("DOMContentLoaded", function () {
  Select(); // Логика кастомного селекта
  Toggle(); // Логика аккордеона
  CopyLink(); // Логика для копирования ссылки из URL или data-href атрибута
  Modal(); // Логика для модального окна
  Tabs(); // Логика для табов
  Slider(); // Логика для слайдера
  Menu();
  ServicesSlider();
  NextSlider();
});
